import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ThriveNotificationRequest,
  ThriveRecommendationRequest,
  ThriveRecommendationResponse,
} from '@patient-ui/shared/models';
import { EnvironmentService } from '@patient-ui/shared-ui/utils';

@Injectable({
  providedIn: 'root',
})
export class ThriveService {
  constructor(
    private readonly http: HttpClient,
    private readonly envService: EnvironmentService
  ) {}

  getRecommendations(
    request: ThriveRecommendationRequest
  ): Observable<ThriveRecommendationResponse> {
    const url = `${this.envService.baseUrl}/protected/patients/current/thrive/recommendations`;
    return this.http.post<ThriveRecommendationResponse>(url, request);
  }

  sendEvent(request: ThriveNotificationRequest): Observable<void> {
    const url = `${this.envService.baseUrl}/protected/patients/current/thrive/events`;
    return this.http.post<void>(url, request);
  }
}
